const CHECKOUT_SESSION_PLACEHOLDER = '{CHECKOUT_SESSION_ID}';

export interface CheckoutRedirectUrls {
  successUrl: string;
  cancelUrl: string;
}

/**
 * Builds Stripe Checkout redirect URLs from the current app origin.
 * Prefer passing these from the client so misconfigured server env cannot swap success/cancel.
 */
export function buildCheckoutRedirectUrls(baseOrigin?: string): CheckoutRedirectUrls {
  const origin = (baseOrigin ?? (typeof window !== 'undefined' ? window.location.origin : ''))
    .replace(/\/$/, '');
  if (!origin) {
    return {
      successUrl: `/payment/success?session_id=${CHECKOUT_SESSION_PLACEHOLDER}`,
      cancelUrl: '/payment/cancel',
    };
  }
  return {
    successUrl: `${origin}/payment/success?session_id=${CHECKOUT_SESSION_PLACEHOLDER}`,
    cancelUrl: `${origin}/payment/cancel`,
  };
}
